define('Cart.Item.Actions.View.CoreChargeItem', [
    'Cart.Item.Actions.View',
    'underscore',
    'cart_item_actions_core_charge_item.tpl'
], function CartItemActionsViewMattressFee(
    CartItemActionsView,
    _,
    cartItemActionsTpl
) {
    'use strict';

    var viewPrototype = CartItemActionsView.prototype;
    if (viewPrototype) {
        _.extend(viewPrototype, {
            template: cartItemActionsTpl
        });
    }
});
